import { ICopyGedDocumentoUseCase } from "../../../presentation/useCases/create/copy_ged_documento_use_case";
import { UserFriendlyError } from "../../../utils/base_error";
import { TelasIds } from "../../../utils/tela_ids";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * CopyGedDocumentoUseCase
 */

export class CopyGedDocumentoUseCase implements ICopyGedDocumentoUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async copyGedDocumento(
    idTela: TelasIds,
    idGedDocumento: number,
    arquivo: string,
    observacoes: string | null,
    file: File | null,
    filePdf: File | null,
    cleanFile: boolean,
    cleanFilePdf: boolean,
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.copyGedDocumento(
      idTela,
      idGedDocumento,
      null,
      null,
      arquivo,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      observacoes,
      null,
      null,
      null,
      null,
      null,
      null,
      file,
      filePdf,
      cleanFile,
      cleanFilePdf,
    );
  }

  async copyGedDocumentoInterno(
    idTela: TelasIds,
    idGedDocumento: number,
    statusArquivo: number,
    tipo: number,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    revisadoPor: number | null,
    aprovadoPor: number | null,
    responsavelProcesso: number | null,
    localArmazenamento1: string | null,
    localArmazenamento2: string | null,
    acesso: string | null,
    recuperacao: string | null,
    protecao: string | null,
    retencao: string | null,
    disposicao: string | null,
    observacoes: string | null,
    file: File | null,
    filePdf: File | null,
    cleanFile: boolean,
    cleanFilePdf: boolean,
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.copyGedDocumento(
      idTela,
      idGedDocumento,
      statusArquivo,
      tipo,
      arquivo,
      versao,
      centroCusto,
      revisadoPor,
      aprovadoPor,
      responsavelProcesso,
      localArmazenamento1,
      localArmazenamento2,
      acesso,
      recuperacao,
      protecao,
      retencao,
      disposicao,
      observacoes,
      null,
      null,
      null,
      null,
      null,
      null,
      file,
      filePdf,
      cleanFile,
      cleanFilePdf,
    );
  }

  async copyGedDocumentoExterno(
    idTela: TelasIds,
    idGedDocumento: number,
    statusArquivo: number,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    local1: string | null,
    local2: string | null,
    assunto: string | null,
    conferirAtualizacao: Date | null,
    ondeConsultar: string | null,
    dataVencimento: Date | null,
    dataPublicacao: Date | null,
    dataVigencia: Date | null,
    file: File | null,
    filePdf: File | null,
    cleanFile: boolean,
    cleanFilePdf: boolean,
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.copyGedDocumento(
      idTela,
      idGedDocumento,
      statusArquivo,
      null,
      arquivo,
      versao,
      centroCusto,
      null,
      null,
      null,
      local1,
      local2,
      null,
      null,
      null,
      null,
      null,
      null,
      assunto,
      conferirAtualizacao,
      ondeConsultar,
      dataVencimento,
      dataPublicacao,
      dataVigencia,
      file,
      filePdf,
      cleanFile,
      cleanFilePdf,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }
}
